import { businessKey } from 'queryKeys';

const screenQuery = businessKey.query('gallery').query('ai-chatbot');

const messagesQuery = screenQuery.query('messages');

export const messages = messagesQuery.exact('list');
export const messageMutations = messagesQuery.mutations();

export const submitMessage = messageMutations.mutate('submit');
